import * as React from "react";
import { User, Role } from "../../api/classes";
import Table from "./table";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import Loading from "../../components/loading";

interface Props {
  mailList: User[];
  fetchMailList: () => void;
}
class Users extends React.Component<Props> {
  componentWillMount() {
    if (!this.props.mailList) {
      this.props.fetchMailList();
    }
  }
  render() {
    if (!this.props.mailList) {
      return <Loading />;
    }
    return (
      <div
        style={{
          flex: 1,
          padding: 24,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowY: "scroll"
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 1000,
            marginLeft: 24,
            marginRight: 24
          }}
        >
          <Table classes={{}} elements={this.props.mailList} />
        </div>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    mailList: state.cases.mailList
  }),
  dispatch => ({
    fetchMailList: (): any => dispatch(actions.fetchMailList())
  })
)(Users);



// WEBPACK FOOTER //
// ./src/pages/mailList/index.tsx